import { useQuery } from '@tanstack/react-query';
import jobPostingApi from '../api/jobPosting';

const useJobPostingChoices = () => {
    const { data, isLoading, isError, error } = useQuery({
    queryKey: ['job-posting-choices'],
    queryFn: async () => {
      const res = await jobPostingApi.getJobPostingChoices()
      return res.data;
    },
  });
  return {
    data, isLoading
  }
}

export default useJobPostingChoices